import api from './api';

export const adminService = {
  getAllUsers: async () => {
    const response = await api.get('/admin/users');
    return response.data;
  },

  updateUserStatus: async (userId, status) => {
    const response = await api.put(`/admin/users/${userId}/status`, { status });
    return response.data;
  },

  updateUserAdminStatus: async (userId, isAdmin) => {
    const response = await api.put(`/admin/users/${userId}/admin`, { isAdmin });
    return response.data;
  }
};